import { useOutletContext } from 'react-router-dom'

import { TrainingsSessionFile } from 'generated/resources/datatable.graphql'

export const useSessionFilesContext = () =>
  useOutletContext<{ sessionFiles: TrainingsSessionFile[] }>()

export type SessionFile = TrainingsSessionFile
